/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { RecaptchaCheckbox } from 'shared-ui/recaptcha';
import { SharedCaptchaModal } from 'shared-ui/components/RecaptchaModal/SharedCaptchaModal';

export default function RecaptchaChallengeModal({
    isOpen,
    onClose,
    onContinue,
    recaptcha,
    isSubmitting,
    action,
}) {
    return (
        <SharedCaptchaModal
            isOpen={isOpen}
            onRequestClose={onClose}
            onContinue={onContinue}
            heading="Confirm You're Not a Robot"
            showCancelButton
            isContinueDisabled={recaptcha.isV2Invalid}
            isContinueLoading={isSubmitting}
        >
            Please complete the challenge below to continue with your reservation.
            <RecaptchaCheckbox
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...recaptcha.recaptchaCheckboxProps}
                isFallbackOnly
                action={action}
            />
        </SharedCaptchaModal>
    );
}

RecaptchaChallengeModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    recaptcha: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool,
    action: PropTypes.string.isRequired,
};
